import React from 'react'
import { CustomAlert } from "./style";

const Alert = props => {
  const { info } = props
  const { visible, type, message } = info

  return (
    <CustomAlert visible={visible} type={type}>
      {message}
    </CustomAlert>
  )
}

export default Alert